import React from 'react';
import { connect } from 'react-redux';

import BCLLoading from '../common/Loading/BCLLoading';
import { withBaseContainer } from '../BaseContainer';
import { prepareHerChunks, getDataForPdfSanity } from '../../helpers/herHelper';

import { PRODUCT_TYPE, FONT_STATUS, DEFAULT_HER_MODULES_ORDER, HER_MODULE_EVENT } from "../../constants/common";
import { isEmptyObject, getBECompatibleLocale } from "../../helpers/helper";
import { fetchApplianceMapping } from "../../dataFetchers/appliancesDataFetcher";
import { setHERModules } from '../../actions/herActions';
import { postPdfSanityData } from '../../dataFetchers/herDataFetcher';

import './HER.scss';

class HERContainer extends React.Component {
  state = {chunks: null};
  componentDidMount() {
    const {userIdentityDetails, queryParams, configs, fetchApplianceMapping, herData, setHERModules } = this.props;

    let locale = getBECompatibleLocale(configs.data);
    fetchApplianceMapping({uuid: userIdentityDetails.userId, locale: locale});

    // set HER modules order from queryParam or set default order
    if (herData && !herData.modulesToBeLoaded.length) {
      const herModulesOrder = queryParams.herModulesOrder ? queryParams.herModulesOrder.split(',') : DEFAULT_HER_MODULES_ORDER;
      setHERModules(herModulesOrder);
    }
  }

  componentDidUpdate() {
    const { herData, fontData, queryParams, userIdentityDetails } = this.props;
    // prepare chunks to render and used setState to trigger render method again
    if (herData && herData.modulesToBeLoaded.length >= 0) {
      if (herData.herEvent === HER_MODULE_EVENT.MODULES_TO_BE_LOADED && !this.state.chunks) {
        const chunks = prepareHerChunks([...herData.modulesToBeLoaded]);
        this.setState({...this.state, chunks});
      }

      if (herData.herEvent === HER_MODULE_EVENT.MODULE_LOADED) {
        let allModulesLoaded = herData.modulesToBeLoaded.every((module) => {
          return herData.modulesLoaded.includes(module);
        });

        // trigger hidden element on the page if all modules and font has been loaded, so PDF generation service can save this page as PDF
        if (allModulesLoaded && fontData.fontStatus === FONT_STATUS.ACTIVE && queryParams.fileName) {
          //scrap rendered data from HTML and pass back to sanity api so BE will do the data sanity and further process the PDF
          let dataForPdfSanity = getDataForPdfSanity(herData.modulesToBeLoaded, queryParams);
          postPdfSanityData({
            uuid: userIdentityDetails.userId,
            pdfName: queryParams.fileName
          }, dataForPdfSanity).then(result => {
            if (result) {
              setTimeout(() => {
                let ele = document.createElement('div');
                ele.id = 'print-report-loaded';
                document.body.appendChild(ele);
              }, 0);
            }
          });
        }
      }
    }
  }

  render () {
    return (
      <>
        { !isEmptyObject(this.props.appliancesList) && this.state.chunks &&
        <div className="her-container">
          <React.Suspense fallback={<BCLLoading />}>
            {
              this.state.chunks.map((chunk, index) => {
                return (
                  <div className="page" key={index}>
                    {
                      chunk.map((HERModule, index) => {
                        return (
                          <HERModule.module key={index} {...this.props} herModuleName={HERModule.name}/>
                        )
                      })
                    }
                  </div>
                )
              })
            }
          </React.Suspense>
        </div>
        }
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    herData: state.herData,
    fontData: state.fontData,
    configs: state.configs,
    translationsData: state.translationsData.data,
    queryParams: state.queryParams,
    appliancesList: state.appliances.appliancesList
  }
};

const mapDispatchToProps = dispatch => {
  return {
    fetchApplianceMapping: (options) => dispatch(fetchApplianceMapping(options)),
    setHERModules: (herModulesOrder) => dispatch(setHERModules(herModulesOrder))
  }
};

export default withBaseContainer(connect(mapStateToProps, mapDispatchToProps)(HERContainer), PRODUCT_TYPE.HER);